import { createFileRoute } from '@tanstack/react-router';

import { billingProductScreen, billingProductSearch, loadBillingProductScreens } from '@/modules/billing-product/route';
import { lazyScreen } from '@/shared/screen';

// Produtos de Cobrança no caminho do menu do legado (`router.tsx:1804`): `screens.byPath('/cadastro/gestao')`
// acha o manifesto e o menu vira link interno. As abas do legado (caminhos próprios) viram `?tab=` (U42).
// Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/cadastro/gestao/')({
  validateSearch: billingProductSearch,
  staticData: { screen: billingProductScreen },
  component: lazyScreen(loadBillingProductScreens, 'BillingProductHubRoute'),
});
